import { Network } from 'lucide-react'
import { Link, useLocation } from 'react-router'
import { LoadBalancerSwitcher } from '@/components/layout/breadcrumbs/load-balancer/load-balancer-switcher'
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip'
import { useCompanyPath } from '@/lib/hooks'

const LoadBalancerIconBreadcrumbItem = () => {
  const { getCompanyPath } = useCompanyPath()
  return (
    <BreadcrumbItem>
      <Link to={getCompanyPath({ pathname: '/load-balancers' })}>
        <Tooltip delayDuration={1000}>
          <BreadcrumbPage className="cursor-pointer p-2 flex items-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground">
            <TooltipTrigger>
              <BreadcrumbLink asChild>
                <div className="cursor-pointer">
                  <Network className="size-3.5" />
                  <span className="sr-only">Load balancer</span>
                </div>
              </BreadcrumbLink>
            </TooltipTrigger>
          </BreadcrumbPage>
          <TooltipContent sideOffset={8}>
            <span>Load balancer</span>
          </TooltipContent>
        </Tooltip>
      </Link>
    </BreadcrumbItem>
  )
}

export const LoadBalancerBreadcrumbs = () => {
  const { pathname } = useLocation()

  return (
    <>
      {pathname === '/load-balancers' ? (
        <BreadcrumbItem>
          <BreadcrumbPage className="flex items-center gap-2 px-2">
            <Network className="size-3.5" />
            <span className="font-medium">Load balancers</span>
          </BreadcrumbPage>
        </BreadcrumbItem>
      ) : null}
      {pathname === '/load-balancers/create' ? (
        <>
          <LoadBalancerIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage className="px-2 font-medium">
              Create load balancer
            </BreadcrumbPage>
          </BreadcrumbItem>
        </>
      ) : null}
      {pathname.startsWith('/load-balancer/') &&
      pathname !== '/load-balancers/create' ? (
        <>
          <LoadBalancerIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <LoadBalancerSwitcher />
        </>
      ) : null}
    </>
  )
}
